export function isEnterKeyPress(event) {
  return event.key === 'Enter' || event.keyCode === 13;
}
